import {webserverServiceProUrl} from '.';
import {IStatusInformationResponse} from '@elproag/webserver-service-pro';
import {getDefaultOpts} from '..';

const baseUrl = `${webserverServiceProUrl}/api/web/system`;

export async function GetSystemInformation(): Promise<IStatusInformationResponse> {
	const response = await fetch(`${baseUrl}/statusInformation`, {
		method: 'GET',
		...getDefaultOpts(),
	});

	if (!response.ok) {
		console.error(await response.text());
		return Promise.reject(new Error('Failed to fetch system information'));
	}

	return (await response.json()) as IStatusInformationResponse;
}
